import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Options = ({ onRegisterClick, onForgotPasswordClick }) => {
    const { t } = useTranslation();

    return (
        <OptionsContainer>
            <ForgotRow>
                <OptionButton
                    type="button"
                    onClick={onForgotPasswordClick}
                    disabled={!onForgotPasswordClick}
                >
                    {t('LoginPage.forgot_password')}
                </OptionButton>
            </ForgotRow>
            <RegisterRow>
                <span>{t('LoginPage.no_account')}</span>
                <OptionButton
                    type="button"
                    onClick={onRegisterClick}
                    disabled={!onRegisterClick}
                >
                    {t('LoginPage.register')}
                </OptionButton>
            </RegisterRow>
        </OptionsContainer>
    );
};

const OptionsContainer = styled.div`
    margin-top: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    font-size: 0.875rem;
`;

const ForgotRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const RegisterRow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    color: #6b7280;
    font-size: 0.875rem;
`;

const OptionButton = styled.button`
    background: none;
    color: ${({ theme }) => theme.colors.brand};
    border: none;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 700;
    text-decoration: none;
    transition: color 0.3s;

    &:disabled {
        color: ${({ theme }) => theme.colors.brandLight};
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        color: ${({ theme }) => theme.colors.brand};
        text-decoration: underline;
    }
`;

export default Options;
